import { generateRandomRgbColor } from "utils/generateRandomRgbColor";
import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";

interface ResolveGroupColorArgs {
  groupName: string;
  byGroupId: Record<string, GroupedSmartSurveyorElement[]>;
}

export const resolveGroupColor = ({
  groupName,
  byGroupId,
}: ResolveGroupColorArgs): [number, number, number] => {
  const existingElements = byGroupId[groupName];
  if (existingElements?.[0]) return existingElements[0].rgb;
  return generateRandomRgbColor();
};
